import { Grid, Typography } from "@mui/material";
import React from "react";

function ShowDataRows({ data }) {
    const ShowRow = (k, v) => {
        return <>k</>;
    };
    if (data) {
        console.log(data);
        Object.keys(data).forEach(function (k, v) {
            ShowRow(k);
            // return (
            //     <Grid container spacing={2}>
            //         test
            //         {/* <Grid item mt={1} md={4} sm={6}>
            //             <Typography variant="span">
            //                 <Typography variant="span" mr={3} className="title">
            //                     {k}:
            //                 </Typography>
            //                 <Typography variant="span" className="text-gray">
            //                     {data[k]}
            //                 </Typography>
            //             </Typography>
            //         </Grid> */}
            //     </Grid>
            // );
        });
    }
}

export default ShowDataRows;
